import { Box, Divider } from "@mui/material";
import { DotLegalFullScreenSpinner } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import OverviewStepSection from "./OverviewStepSection.tsx";
import { FieldValue, OverviewStep } from "./OverviewStepSection.types.ts";
import { EntityType } from "@common/Common.types.ts";

export interface AllEntityInfoProps {
    entityId: string;
    entityType: EntityType;
    steps: Array<OverviewStep> | undefined;
    isLoading: boolean;
    getFieldDisplayName: (field: FieldValue, dictionary: Record<string, any>) => string;
    dictionary: Record<string, any>;
    getNavigateUrl?: (entityId: string, stepOrder: number) => string;
    minHeight: number;
    showRelationsAsField?: boolean;
}

function AllEntityInfo(props: AllEntityInfoProps) {
    return (
        <>
            {props.isLoading ? (
                <Box sx={{ height: props.minHeight }}>
                    <DotLegalFullScreenSpinner />
                </Box>
            ) : (
                <Box sx={{ paddingX: 0.5 }}>
                    {(props.steps ?? [])
                        .filter((x) => x.fields.length > 0 || x.showsRelations)
                        .map((x, i, arr) => (
                            <React.Fragment key={i}>
                                <OverviewStepSection
                                    step={x}
                                    entityId={props.entityId}
                                    entityType={props.entityType}
                                    getFieldDisplayName={props.getFieldDisplayName}
                                    dictionary={props.dictionary}
                                    navigateUrl={x.canNavigate ? props.getNavigateUrl?.(props.entityId, x.stepOrder) : undefined}
                                    canNavigate={x.canNavigate}
                                    showRelationsAsField={props.showRelationsAsField}
                                />
                                {i < arr.length - 1 && <Divider sx={{ my: 2 }} />}
                            </React.Fragment>
                        ))}
                </Box>
            )}
        </>
    );
}

export default AllEntityInfo;
